import { Order } from '@/coreDomainsModule/entities/order';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { PartialDeliveryRequest, UpdateOrderInfoRequest } from '@/coreInfrastructureModule/axios/generated/orderManage';

/**
 * 発注データを発注更新リクエストデータに変換する
 */
export class UpdateOrderInfoRequestAdapter {
  /**
   * 変換する
   * @param order - 発注
   */
  public static adapt(order: Order): UpdateOrderInfoRequest {
    const updateOrderInfoRequest: UpdateOrderInfoRequest = {
      putOrderInfo: [
        {
          orderId: order.orderId,
          orderNumber: order.orderNumber || undefined,
          orderAmount: order.orderAmount.toString(),
          orderStatus: order.orderStatus,
          orderNote: order.orderNote,
          orderEstimateTimeOfArrival: DateService.formatDateToISOString(
            DateService.convertUnixTimeToDate(order.estimatedTimeOfArrival / 1000)
          ),
          updateAt: order.updatedAt,
          partialDeliveryList: order.partialDeliveries.map(
            (v): PartialDeliveryRequest => ({
              partialDeliveryId: v.id,
              partialDeliveryNumber: v.partialDeliveryNumber,
              orderAmount: v.orderAmount,
              deliveryDate: DateService.formatDateToISOString(DateService.convertUnixTimeToDate(v.deliveryDate / 1000)),
              partialDeliveryStatus: v.orderStatus,
              updatedAt: v.updatedAt,
            })
          ),
        },
      ],
    };
    return updateOrderInfoRequest;
  }
}
